export default __webpack_public_path__ + "static/media/Chestguard of the Wicked.a61a9ec2.jpg";